@if ($isBootstrapFinished() && $currentUser() != null) {
    <div class="wrapper px-1">
        <!-- Seletor de papel -->
        @if ($shouldShowPapelSelector()) {
            <papel-selector [_signerId]="$inputData().eDocsData.signerId"
                            [_isReadOnly]="$isReadOnly()"
                            [_papeis]="$papeisSelector()"
                            [_flowObjectType]="FlowObjectType.StartInboundApi"
                            (_signerIdChange)="signerIdChange($event)"
            ></papel-selector>
            <hr />
        }

        @if ($pdfFiles().length > 0 && !$isTaskPublicAgentActor()) {
            <!-- Task body: visão do executor -->
            <div class="message-container">
                <div>Documentos para captura no E-Docs:</div>
                <div class="documents-container mt-3">
                    @for (file of $pdfFiles(); track file) {
                        <div class="position-relative my-1">
                            <span class="document-highlight">
                                <span class="info-font d-inline-block">
                                    <span class="filename">{{file.filename}}</span>
                                </span>
                            </span>
                        </div>
                    }
                </div>
            </div>
        }

        @if (!$hasPendingTask()) {
            <!-- Task info: Realizada -->
            <div class="message-container">
                <div class="mb-3">
                    Documentos capturados no E-Docs
                </div>
            </div>
        } @else {
            <!-- Task info: Iniciada -->
            @if ($isTaskPublicAgentActor()) {
                <!-- Task body: visão do agente público -->
                <div class="message-container">
                    <div class="mb-3">
                        Aguardando captura de Documentos no E-Docs pelo usuário instanciador
                    </div>
                </div>
            } @else {
                <!-- Task footer: visão do executor -->
                <div class="form-container">
                    @if (Utils.isNotNullOrEmpty($publicMessageHtml())) {
                        <hr />
                        <div class="public-message py-1"
                             [class.loading]="$isPublicMessageHtmlLoading()"
                             [safeHtmlContent]="$publicMessageHtml()"
                        >{{Enums.Messages.DefaultLoadingText}}</div>
                    }

                    <div class="mt-4">
                        <formio class="formio"
                                [form]="$formSchema()"
                                [renderOptions]="{ language: 'pt' }"
                                [options]="formioOptions"
                                [readOnly]="$isReadOnly()"
                                [submission]="$inputData()"
                                (submit)="onSubmit($event)"
                        ></formio>
                    </div>
                </div>
            }
        }
    </div>
} @else {
    <div class="wrapper loading">
        <span class="info-font text-highlight p-2">(Carregando...)</span>
    </div>
}
